import PropTypes from 'prop-types';
import React from 'react';

export default function ProvedorContextos(props) {
  const { components = [], children } = props;

  return (
    <>
      {components.reduceRight(
        (acc, Component) => (
          <Component>{acc}</Component>
        ),
        children
      )}
    </>
  );
}

ProvedorContextos.propTypes = {
  components: PropTypes.arrayOf(PropTypes.func).isRequired,
  children: PropTypes.node.isRequired,
};
